import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/filterIcon_Disabled.svg'
import _imports_1 from '@/assets/filter.svg'
import _imports_2 from '@/assets/cancel.svg'


const _hoisted_1 = { class: "flexcontainer pt-3 pl-5 pr-5" }
const _hoisted_2 = { class: "row w-full flex justify-between items-center" }
const _hoisted_3 = { class: "flex gap-3" }
const _hoisted_4 = {
  key: 0,
  src: _imports_0,
  class: "filterIcon"
}
const _hoisted_5 = {
  key: 1,
  src: _imports_1,
  class: "filterIcon"
}
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "flex items-center justify-between popupheadingcontainer rounded" }
const _hoisted_9 = { class: "flex flex-col h-full" }
const _hoisted_10 = { class: "flex-1 overflow-auto" }
const _hoisted_11 = { class: "popup-business popupbodycontainer" }
const _hoisted_12 = { class: "row flex" }
const _hoisted_13 = { class: "upperspacing w-full" }
const _hoisted_14 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_15 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { key: 2 }
const _hoisted_18 = { class: "row flex" }
const _hoisted_19 = { class: "upperspacing w-full" }
const _hoisted_20 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_21 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { key: 2 }
const _hoisted_24 = { class: "row flex" }
const _hoisted_25 = { class: "upperspacing w-full" }
const _hoisted_26 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_27 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_28 = { key: 1 }
const _hoisted_29 = { key: 2 }
const _hoisted_30 = { class: "buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5" }
const _hoisted_31 = ["disabled"]
const _hoisted_32 = ["disabled"]
const _hoisted_33 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_newTable = _resolveComponent("newTable")!
  const _component_tool_tip = _resolveComponent("tool-tip")!
  const _component_popup = _resolveComponent("popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[15] || (_cache[15] = _createElementVNode("h1", null, "Vulnerabilities", -1)),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.pageType == false)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "float-right btnprimary",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showPopupVulnerability()))
            }, "Add"))
          : _createCommentVNode("", true),
        _createElementVNode("input", {
          type: "file",
          class: "hidden",
          accept: ".xls,.xlsx",
          ref: "file",
          onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.fileReader($event)))
        }, null, 544),
        _createElementVNode("button", {
          class: _normalizeClass(["float-right flex items-center", _ctx.vulnerabilities.length == 0 ? 'btndisabled pointer-events-none' : 'filterButton']),
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.filterOpen && _ctx.filterOpen(...args)))
        }, [
          (_ctx.vulnerabilities.length == 0)
            ? (_openBlock(), _createElementBlock("img", _hoisted_4))
            : (_openBlock(), _createElementBlock("img", _hoisted_5)),
          _cache[14] || (_cache[14] = _createTextVNode(" Filters "))
        ], 2)
      ])
    ]),
    _cache[28] || (_cache[28] = _createElementVNode("div", { class: "mt-3 text-xs" }, [
      _createElementVNode("div", null, " Vulnerability is a weak point, flaw, error, or gap in the security environment of an asset. The weakness is exploited by the possible object to force its way into getting unauthorized access to the system.Threats will exist but if there are no vulnerabilities, there are limited or zero chances of risk. Hence, knowing about common vulnerabilities and regular tracking of those is critical to identifying potential risks to assets. ")
    ], -1)),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", null, [
        _createVNode(_component_newTable, {
          tableRowData: _ctx.vulnerabilities,
          headersData: _ctx.headers,
          openPopup: _ctx.handlePopUp,
          loadData: _ctx.dataLoading
        }, null, 8, ["tableRowData", "headersData", "openPopup", "loadData"]),
        (_ctx.toolTipActive)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode(_component_tool_tip, { tipText: _ctx.toolTipText }, null, 8, ["tipText"])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.showPopup)
      ? (_openBlock(), _createBlock(_component_popup, { key: 0 }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_8, [
              _cache[17] || (_cache[17] = _createElementVNode("h1", null, "Vulnerability", -1)),
              _createElementVNode("button", {
                class: "float-right text-3xl",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.cancelBtn('close')))
              }, _cache[16] || (_cache[16] = [
                _createElementVNode("img", {
                  src: _imports_2,
                  class: "h-5 w-5 cursor-pointer"
                }, null, -1)
              ]))
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _cache[20] || (_cache[20] = _createElementVNode("label", {
                        class: "controllabel font-normal text-sm mb-1",
                        for: "vulnerability"
                      }, "Vulnerability ID", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.newVulnerability.vulnerabilityId) = $event)),
                        placeholder: "ID",
                        onInput: _cache[5] || (_cache[5] = ($event: any) => (_ctx.restrictCharacters('VulnerabilityId'))),
                        id: "id",
                        class: _normalizeClass(["inputboxstyling", {
                                'is-invalid': (_ctx.v$.newVulnerability.vulnerabilityId.$error||_ctx.displayErrorMessageOfVulnerabilityId ||_ctx.uniqueVulnerabilityId == true)
                            }])
                      }, null, 34), [
                        [
                          _vModelText,
                          _ctx.newVulnerability.vulnerabilityId,
                          void 0,
                          { trim: true }
                        ]
                      ]),
                      (_ctx.v$.newVulnerability.vulnerabilityId.$error)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                            (_ctx.v$.newVulnerability.vulnerabilityId.required.$invalid)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_15, "ID is required"))
                              : _createCommentVNode("", true)
                          ]))
                        : (_ctx.displayErrorMessageOfVulnerabilityId == true)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_16, _cache[18] || (_cache[18] = [
                              _createElementVNode("div", { class: "text-red-500 text-xs" }, "Character Limit is exceeded", -1)
                            ])))
                          : (_ctx.uniqueVulnerabilityId == true)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_17, _cache[19] || (_cache[19] = [
                                _createElementVNode("div", { class: "text-red-500 text-xs" }, "Vulnerability Id already Exists", -1)
                              ])))
                            : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _cache[23] || (_cache[23] = _createElementVNode("label", {
                        class: "controllabel font-normal text-sm mb-1",
                        for: "vulnerability"
                      }, "Category", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.newVulnerability.category) = $event)),
                        onInput: _cache[7] || (_cache[7] = ($event: any) => (_ctx.restrictCharacters('VulnerabilityCategory'))),
                        onChange: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.resetEventError && _ctx.resetEventError(...args))),
                        placeholder: "Category",
                        id: "category",
                        class: _normalizeClass(["inputboxstyling", {
                                'is-invalid': _ctx.v$.newVulnerability.category.$error||_ctx.displayErrorMessageOfVulnerabilityCategory||_ctx.uniqueVulnerabilityCategory
                            }])
                      }, null, 34), [
                        [
                          _vModelText,
                          _ctx.newVulnerability.category,
                          void 0,
                          { trim: true }
                        ]
                      ]),
                      (_ctx.v$.newVulnerability.category.$error)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                            (_ctx.v$.newVulnerability.category.required.$invalid)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_21, "Category is required"))
                              : _createCommentVNode("", true)
                          ]))
                        : (_ctx.displayErrorMessageOfVulnerabilityCategory == true)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_22, _cache[21] || (_cache[21] = [
                              _createElementVNode("div", { class: "text-red-500 text-xs" }, "Character Limit is exceeded", -1)
                            ])))
                          : (_ctx.uniqueVulnerabilityCategory == true)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_23, _cache[22] || (_cache[22] = [
                                _createElementVNode("div", { class: "text-red-500 text-xs" }, "This vulnerability category already exists", -1)
                              ])))
                            : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                      _cache[26] || (_cache[26] = _createElementVNode("label", {
                        class: "controllabel font-normal text-sm mb-1",
                        for: "vulnerability"
                      }, "Vulnerability", -1)),
                      _withDirectives(_createElementVNode("textarea", {
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.newVulnerability.vulnerability) = $event)),
                        placeholder: "Vulnerability",
                        id: "vulnerability",
                        onInput: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.resetEventError && _ctx.resetEventError(...args))),
                        class: _normalizeClass(["inputboxstyling", {
                                'is-invalid': _ctx.v$.newVulnerability.vulnerability.$error||_ctx.displayErrorMessageOfVulnerability||_ctx.uniqueVulnerability
                            }])
                      }, null, 34), [
                        [
                          _vModelText,
                          _ctx.newVulnerability.vulnerability,
                          void 0,
                          { trim: true }
                        ]
                      ]),
                      (_ctx.v$.newVulnerability.vulnerability.$error)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                            (_ctx.v$.newVulnerability.vulnerability.required.$invalid)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_27, "Vulnerability is required"))
                              : _createCommentVNode("", true)
                          ]))
                        : (_ctx.displayErrorMessageOfVulnerability == true)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_28, _cache[24] || (_cache[24] = [
                              _createElementVNode("div", { class: "text-red-500 text-xs" }, "Character Limit is exceeded", -1)
                            ])))
                          : (_ctx.uniqueVulnerability == true)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_29, _cache[25] || (_cache[25] = [
                                _createElementVNode("div", { class: "text-red-500 text-xs" }, "This vulnerability already exists", -1)
                              ])))
                            : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", null, [
                _cache[27] || (_cache[27] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey mx-5" }, null, -1)),
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("button", {
                    disabled: _ctx.clickOnButton,
                    class: _normalizeClass(["btnprimary mr-1.5", _ctx.disableStatus ? 'btnprimary' : 'btndisabled pointer-events-none']),
                    onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.cancelBtn(_ctx.newVulnerability._id)))
                  }, "Reset", 10, _hoisted_31),
                  (!_ctx.editVulnerability)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        disabled: _ctx.clickOnButton,
                        onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.addOrUpdatevulnerability())),
                        class: _normalizeClass(_ctx.disableStatus ? 'btnprimary' : 'btndisabled pointer-events-none')
                      }, "Save", 10, _hoisted_32))
                    : (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        disabled: _ctx.clickOnButton,
                        class: _normalizeClass(["btnprimary mr-1.5", _ctx.disableStatus ? 'btnprimary' : 'btndisabled pointer-events-none']),
                        onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.addOrUpdatevulnerability()))
                      }, "Update", 10, _hoisted_33))
                ])
              ])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}